import * as React from 'react';
import { format } from 'date-fns';
import NextImage from 'next/image';
import { toSlug } from 'utils/shared/string/generateSlug';
import Link from 'components/Link';

interface Props {
  author: {
    name: string;
    jobTitle?: string;
    image?: {
      asset?: {
        url: string;
      };
    };
  };
  publishedAt?: string;
  readingTime?: number;
  showDate?: boolean;
}

export default function AuthorByline({ author, publishedAt, readingTime, showDate = true }: Props) {
  const authorHref = author?.name ? `/author/${toSlug(author.name)}` : null;

  const nameNode = (
    <span className="typography-product-subheading text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
      {author.name}
    </span>
  );

  return (
    <div className="flex items-center justify-start">
      {author?.image?.asset?.url && (
        <NextImage
          src={author.image.asset.url}
          alt={author.name}
          className="rounded-full"
          loading="lazy"
          height={56}
          width={56}
        />
      )}
      <div className="ml-3 flex flex-col">
        {authorHref ? (
          <Link href={authorHref} className="hover:underline">
            {nameNode}
          </Link>
        ) : (
          nameNode
        )}
        {author.jobTitle && (
          <span className="typography-product-caption text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
            {author.jobTitle}
          </span>
        )}
        {showDate && publishedAt && (
          <span className="typography-product-caption text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
            Published {format(new Date(publishedAt), 'd LLL yyyy')}
            {readingTime && ` · ${readingTime} min read`}
          </span>
        )}
      </div>
    </div>
  );
}
